import React from 'react';
import { Box, Typography } from '@mui/material';
import { AppColors } from '../theme/colors';

/**
 * スマホのメニューの一番下に出す製品名。管理画面・一般ユーザー画面の両方で使う。
 *
 * スマホのヘッダーは幅が狭く、製品名と会社名を並べると会社名が省略されてしまうため、
 * 左上は会社名を優先し（坂本様ご指摘⑤）、製品名はこちらへ移した。
 * PCはヘッダーの左上に製品名を残しているので、PC用のメニューには出さない。
 * 親は縦並び（flex column）にしておくこと。mt: 'auto' で一番下に寄せる。
 */
export const SidebarBrand: React.FC = () => (
  <Box
    sx={{
      mt: 'auto',
      px: 3,
      py: 2,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      flexShrink: 0,
    }}
  >
    <Box component="img" src="/icon.svg" alt="" sx={{ width: 20, height: 20 }} />
    <Typography
      sx={{
        fontWeight: 800,
        fontSize: 15,
        letterSpacing: 0.5,
        fontFamily: '"Nunito", "Noto Sans JP", sans-serif',
        color: AppColors.textSecondary,
      }}
    >
      LiaVoice
    </Typography>
  </Box>
);
